import { ErrorBoundary } from "components/Error/ErrorBoundary";
import { useEditor } from "features/editor/Feature";
import type { Editor } from "features/types/editor";
import { onGrid, Stack, Box } from "prism-react";
import React from "react";

import { GlobalModal } from "components/GlobalModal";

import { EditorPreference } from "./EditorPreference";
import { Experiments } from "./Experiments";
import { SettingsEnvVariables } from "./SettingsEnvVariables/SettingsEnvVariables";
import { SettingsModalHeader } from "./SettingsModalHeader";
import { SettingsModalNav } from "./SettingsModalNav";
import { useProjectSettingsContext } from "./SettingsProvider";
import type { Tabs } from "./SettingsProvider";
import { SettingsRepository } from "./SettingsRepository/SettingsRepository";

const getTabContents = (
  type: Editor["type"],
): Partial<
  Record<
    Tabs,
    React.FC<{
      visible: boolean;
      onClose: () => void;
    }>
  >
> => ({
  ...(type === "branch" && { repository: SettingsRepository }),
  env: SettingsEnvVariables,
  preferences: EditorPreference,
  experiments: Experiments,
});

export const ProjectSettingsModal: React.FC = () => {
  const project = useEditor();
  const { visible, setVisibility, activeTab } = useProjectSettingsContext();

  const tabContents = getTabContents(project.type);

  const Content = tabContents[activeTab];

  return (
    <GlobalModal maxWidth={950} open={visible}>
      <ErrorBoundary context="SETTINGS">
        <Stack
          css={{
            height: onGrid(110),
          }}
          gap={6}
        >
          <SettingsModalHeader />
          <Stack css={{ minHeight: 0, flex: 1 }} gap={8} horizontal>
            <SettingsModalNav />
            {Content ? (
              <Box
                css={{
                  height: "100%",
                  width: "100%",
                  marginTop: "$3",
                  overflow: "auto",
                }}
              >
                <Content
                  onClose={() => setVisibility(false)}
                  visible={visible}
                />
              </Box>
            ) : null}
          </Stack>
        </Stack>
      </ErrorBoundary>
    </GlobalModal>
  );
};
